<script lang="ts">
  import type { Snippet } from "svelte";
  import type { ClassValue } from "svelte/elements";

  interface Props {
    class?: ClassValue;
    /*                                                   */
    /*                                                                                                     */
    children?: Snippet;
    items: string[];
    filtered?: string[];
    label: string;
    placeholder?: string;
    emptyMessage?: string;
    value?: string;
  }

  const specialCharactersPattern = /[^a-zA-ZäöüÄÖÜß0-9]/g;
  let {
    label,
    placeholder = "",
    emptyMessage = "",
    filtered = $bindable([]),
    value = $bindable(""),
    items = [],
  }: Props = $props();

  let searchTerm = $state("");

  $effect(() => {
    const cleanedSearchTerm = searchTerm.replace(specialCharactersPattern, "");
    filtered = items.filter((item) =>
      item.toLowerCase().replace(specialCharactersPattern, "").includes(cleanedSearchTerm.toLowerCase()),
    );
  });
</script>

<oc-text-field-v1
  {placeholder}
  type="text"
  value=""
  {...filtered.length === 0 && value === "" ? { disabled: true } : {}}
  validation-message={filtered.length === 0 && value !== "" ? emptyMessage : null}
  oninput={(v: Event) => {
    searchTerm = v.target?.value || "";
    value = searchTerm;
  }}
>
  {label}
</oc-text-field-v1>
